'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _team = require('./team.accessLogs');

var _team2 = _interopRequireDefault(_team);

var _team3 = require('./team.billableInfo');

var _team4 = _interopRequireDefault(_team3);

var _team5 = require('./team.info');

var _team6 = _interopRequireDefault(_team5);

var _team7 = require('./team.integrationLogs');

var _team8 = _interopRequireDefault(_team7);

var _teamProfile = require('./team.profile.get');

var _teamProfile2 = _interopRequireDefault(_teamProfile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  accessLogs: _team2.default,
  billableInfo: _team4.default,
  info: _team6.default,
  integrationLogs: _team8.default,
  profile: {
    get: _teamProfile2.default
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/slack/methods/team.js
// module id = 440
// module chunks = 0